import api from './api'

export const courseBankStatementService = {
  /**
   * 上传对账单
   */
  uploadBankStatement(courseId, file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.post(`/courses/${courseId}/bank-statements`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  /**
   * 获取课程的对账单列表
   */
  getBankStatements(courseId) {
    return api.get(`/courses/${courseId}/bank-statements`)
  },

  /**
   * 删除对账单
   */
  deleteBankStatement(id) {
    return api.delete(`/courses/bank-statements/${id}`)
  },

  /**
   * 下载样例Excel文件
   */
  async downloadSampleExcel() {
    const response = await api.get(`/courses/bank-statements/sample`, {
      responseType: 'blob'
    })
    // 如果响应是blob类型，直接返回blob数据
    if (response instanceof Blob) {
      return response
    }
    // 否则从response.data中获取blob
    return response.data || response
  }
}

